import { CircularProgress, Stack, Typography } from "@mui/material";

export const LoadingSpinner = () => {
    return (
        <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            spacing={2}
            sx={{
                minHeight: "100vh",
                backgroundColor: "background.default",
            }}
        >
            <CircularProgress size={48} />
            <Typography variant="body1" color="text.secondary">
                Loading...
            </Typography>
        </Stack>
    );
};
